import { Injectable } from '@angular/core';
import { Observable, catchError, of, switchMap, tap } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { apiService } from './api.service';
import { ApiLoginResponse } from '../core/interfaces/b2cauth';

@Injectable({
  providedIn: 'root',
})
export class B2cGlobalDataService {

  private username = 'b2cweb';
  private password = 'P@ssw0rd';

  public b2c_auth_token : any = localStorage.getItem('apiLoginToken');

  // Adding a property to store token data
  private tokenData: any = {};

  constructor(private api: apiService) {}

  getLoginData(): { username: string, password: string } {
    return { username: this.username, password: this.password };
  }

  login(): Observable<ApiLoginResponse> {
    const { username, password } = this.getLoginData();
    return this.api.getApiLogin(username, password).pipe(
      switchMap((response: ApiLoginResponse) => {
        const user = response.data[0];
        localStorage.setItem('apiLoginToken', user.token.accessToken);
        localStorage.setItem('apiLoginId', user.token.token.id);
        this.tokenData = user.token;
        return this.checkTokenValidity().pipe(
          switchMap(tokenValidityResponse => {
            if (tokenValidityResponse.expire) {
              return this.getRefreshToken(this.getTokenId()).pipe(
                tap(refreshTokenResponse => {
                  const refreshedUser = refreshTokenResponse.data[0];
                  localStorage.setItem('apiLoginToken', refreshedUser.accessToken);
                  localStorage.setItem('apiLoginId', refreshedUser.token.id);
                  this.tokenData = refreshedUser.token;
                }),
                switchMap(() => {
                  return this.checkTokenValidity();
                }),
                catchError(refreshError => {
                  console.error('Error in getRefreshToken', refreshError);
                  return of('Token refresh error');
                })
              );
            } else {
              return of('Token is valid');
            }
          }),
          catchError(tokenValidityError => {
            console.error('Error in checkTokenValidity', tokenValidityError);
            return of(tokenValidityError);
          })
        );
      }),
      catchError(loginError => {
        console.error('Error in getApiLogin', loginError);
        return of(loginError);
      })
    );
  }

  getApiLoginToken(): string | null {
    return localStorage.getItem('apiLoginToken');
  }

  getTokenId(): string | null {
    return localStorage.getItem('apiLoginId');
  }

  // Updated method to check token validity
  checkTokenValidity(): Observable<any> {
    const tokenId = this.getTokenId();
    const header = { 'Authorization': 'Bearer ' + this.getApiLoginToken() };

    return this.api.getTokenValidity(tokenId, header).pipe(
      catchError(error => {
        return of({ expire: true });
      })
    );
  }

  private getRefreshToken(tokenID: any): Observable<any> {
    console.log('refreshapi called')
    return this.api.getRefreshToken(tokenID);
  }

}
